import { Cell, Label, Legend, Pie, PieChart, ResponsiveContainer } from 'recharts'
import { ContentType } from 'recharts/types/component/DefaultLegendContent'
import { ContentType as LabelContentType } from 'recharts/types/component/Label'
import { PolarViewBox } from 'recharts/types/util/types'
import { theme } from 'tailwind.config.js'

import {
  INNER_RADIUS,
  OUTER_RADIUS
} from 'components/dashboard/analytics-overview/DailyRequestHealthChart/DailyRequestHealthChart'

const gray = theme.extend.colors.gray['700']
const border = theme.extend.colors.border.muted

const NO_DATA = [{ name: 'No Data', value: 1000 }]

const renderLegend: ContentType = () => (
  <div className='mx-auto flex max-w-[340px] justify-center px-4 py-2'>
    <div
      className='text-text-default flex items-center text-center'
      data-testid='daily-request-health-no-data'
      key={`item-empty`}
    >
      No data available yet. Send requests to see your daily request health for today.
    </div>
  </div>
)

export const DailyRequestHealthEmpty = () => {
  const renderCustomLabel: LabelContentType = ({ viewBox }) => {
    const { cx, cy } = viewBox as PolarViewBox
    return (
      <text data-testid='daily-request-health-total' dominantBaseline='central' textAnchor='middle' x={cx} y={cy}>
        <tspan className='fill-text-default text-2xl font-bold' dy='-0.5rem' x='50%'>
          {0}
        </tspan>
        <tspan className='fill-text-alternative' dy='2rem' x='50%'>
          Total
        </tspan>
      </text>
    )
  }

  return (
    <div className='xs:h-[320px] desktop:h-[240px] h-70'>
      <ResponsiveContainer>
        <PieChart>
          <Pie
            data={NO_DATA}
            dataKey='value'
            endAngle={450}
            fill={gray}
            innerRadius={INNER_RADIUS}
            outerRadius={OUTER_RADIUS}
            startAngle={-90}
            stroke={border}
          >
            <Cell fill={gray} key={`cell-empty`} />
            <Label content={renderCustomLabel} position='center' />
          </Pie>
          <Legend content={renderLegend} verticalAlign='bottom' />
        </PieChart>
      </ResponsiveContainer>
    </div>
  )
}
